// Plugins tiers (jQuery, slick, isotope, scrollreveal, gsap...) : chargés avant ce fichier via plugins.min.js
// Chaque bloc expose ses fonctions d'init (blocks/X/scripts.js), appelées dans l'ordre du main.js v1.
import { initHeader, initHeaderMenuScroll } from '../../blocks/header/scripts.js'
import { initToTop, initFooterObfuscated } from '../../blocks/footer/scripts.js'
import { initMaps, initSliderMaps } from '../../blocks/slider-maps/scripts.js'
import { initSeoBlock, initSeoBlockMore } from '../../blocks/seo-block/scripts.js'
import { initLinkImg } from '../../blocks/link-img/scripts.js'
import { initDateImg } from '../../blocks/date-img/scripts.js'
import { initPressePage } from '../../blocks/presse-page/scripts.js'
import { initAccordion } from '../../blocks/accordion/scripts.js'
import { initSliderProduct } from '../../blocks/slider-product/scripts.js'
import { initHeroSliders } from '../../blocks/hero/scripts.js'
import { initTestimonials } from '../../blocks/testimonials/scripts.js'
import { initSliderSimple } from '../../blocks/slider-simple/scripts.js'
import { initSliderDate } from '../../blocks/slider-date/scripts.js'
import { initGallery } from '../../blocks/gallery/scripts.js'
import { initBlogList } from '../../blocks/blog-page/scripts.js'
import { initContact } from '../../blocks/contact/scripts.js'
import initScrollReveal from './utils/scrollreveal.js'
import initGsap from './utils/gsap.js'
import initPrefillCookies from './utils/prefill-cookies.js'
import initTelButtons from './utils/tel-buttons.js'
import initDataLayer from './utils/datalayer.js'

// Le main.js v1 est exécuté en module : initMap doit rester global pour le callback Google Maps
window.initMap = window.initMap || function () {}

initToTop()
initMaps()

jQuery(document).ready(function ($) {
  initHeader($)
  initSeoBlock($)
  initLinkImg($)
  initDateImg($)
  initPressePage($)
  initFooterObfuscated($)
  initAccordion($)
  initScrollReveal($)
  initGsap($)
  initHeaderMenuScroll($)
  initSliderProduct($)
  initHeroSliders($)
  initTestimonials($)
  initSliderSimple($)
  initSliderDate($)
  initSliderMaps($)
  initGallery($)
  initBlogList($)
  initPrefillCookies($)
  initTelButtons($)
  initSeoBlockMore($)
  initDataLayer($)
  initContact($)
})
